var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPwv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.381,
    height: 41.276,
    viewBox: "0 0 41.381 41.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 4.316,
    y1: 18.9,
    x2: 0.65,
    y2: 22.566,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.316,
    y1: 22.566,
    x2: 0.65,
    y2: 18.9,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "35.546 21.437 37.102 22.863 40.731 19.234",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "38.822 11.855 40.466 10.211 38.822 8.567",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "38.85 33.854 40.494 32.21 38.85 30.566",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.417,10.198h-2.197c-2.163,0-3.917,1.754-3.917,3.917v3.148c0,2.163-1.754,3.917-3.917,3.917h0",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.417,32.165h-2.197c-2.163,0-3.917-1.754-3.917-3.917v-3.148c0-2.163-1.754-3.917-3.917-3.917h0",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "2.457 30.566 .814 32.21 2.457 33.854",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2.43 8.567 .786 10.211 2.43 11.855",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.863,32.223h2.197c2.163,0,3.917-1.754,3.917-3.917v-3.148c0-2.163,1.754-3.917,3.917-3.917h0",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.863,10.257h2.197c2.163,0,3.917,1.754,3.917,3.917v3.148c0,2.163,1.754,3.917,3.917,3.917h0",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.64,
    cy: 21.211,
    r: 8.74,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.64,22.249c-3.473-.051-3.472-5.387,0-5.438,3.473.051,3.472,5.387,0,5.438Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.174,27.326c.115-5.89-11.088-5.657-11.069,0",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 20.64,
    y1: 4.046,
    x2: 20.64,
    y2: 12.443,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.64,
    y1: 30.151,
    x2: 20.64,
    y2: 37.079,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.64,
    cy: 2.348,
    rx: 1.68,
    ry: 1.698,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.64,
    cy: 38.928,
    rx: 1.68,
    ry: 1.698,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwv);
export default __webpack_public_path__ + "static/media/PWV.f3371800.svg";
export { ForwardRef as ReactComponent };